import { useState } from 'react';
import { t } from '@/lib/i18n';
import { useRetrievedResources } from '../hooks';
import styles from './MemoryChip.module.css';

interface MemoryChipProps {
  chatMessageId: string;
}

export function MemoryChip({ chatMessageId }: MemoryChipProps) {
  const [expanded, setExpanded] = useState(false);
  const { data } = useRetrievedResources(chatMessageId);
  const items = data?.items ?? [];
  if (items.length === 0) return null;

  const memoryItems = items.filter((m) => m.resourceKind === 'memory_entry');
  const chatItems = items.filter((m) => m.resourceKind === 'chat_message');

  return (
    <div className={styles.chipContainer}>
      <button
        type="button"
        className={styles.chip}
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
      >
        <span aria-hidden="true">🔖</span> {t('{n} items used', { n: items.length })}
      </button>
      {expanded ? (
        <div className={styles.groups}>
          {memoryItems.length > 0 ? (
            <section className={styles.group}>
              <h4 className={styles.groupHeading}>{t('Memories')}</h4>
              <ul className={styles.list}>
                {memoryItems.map((m) => (
                  <li key={m.resourceId} className={styles.item}>
                    <div className={styles.itemContent}>
                      {m.content ?? t('(memory unavailable)')}
                    </div>
                    <div className={styles.itemMeta}>
                      {m.sourceKind === 'chat_pin'
                        ? t('Pinned from chat')
                        : m.sourceKind === 'job_artifact'
                          ? t('From a job output')
                          : null}
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          ) : null}
          {chatItems.length > 0 ? (
            <section className={styles.group}>
              <h4 className={styles.groupHeading}>{t('Earlier turns')}</h4>
              <ul className={styles.list}>
                {chatItems.map((m) => (
                  <li key={m.resourceId} className={styles.item}>
                    <div className={styles.itemContent}>
                      {m.content ?? t('(message unavailable)')}
                    </div>
                    <div className={styles.itemMeta}>
                      {m.sender === 'user' ? t('You said') : t('They said')}
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
